import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  typography: {
    fontFamily: 'Roboto',
    fontSize: 16,
  },
  components: {
    MuiTextField: {
      variants: [
        {
          props: { variant: 'outlined' },
          style: { fontSize: '16px', padding: '5px' },
        },
      ],
      styleOverrides: {
        root: {
          fontSize: '16px',
          padding: '5px',
        },
        input: {
          fontSize: '16px',
          padding: '5px',
        },
      },
    },
  },

  palette: {
    primary: {
      main: '#1378A5',
    },
    secondary: {
      main: '#FFAA01',
    },
    text: {
      main: '#000',
    },
    paper: {
      main: '#fff',
    },
  },
  secodaryColor: '#FFAA01',
  primaryColor: '#1378A5',
});
